import { Box, IconButton, Typography } from "@mui/material";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputFieldGroup,
  CmpInputField,
  CmpStatus,
  CmpCheckboxField,
  CmpExportExcel,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import Grid from "@mui/material/Grid";
export default function Footer({
  vRdxWmsHead,
  xFooterObj,
  fRounding,
  fDiscFlag,
  xBuyer,
  sArr,
  fBuyer,
  fHeadNarration,
  xKey,
  xErrorMsg,
  fFocusRounding,
  fBlurRounding,
  fOpenDiscountPercentageModal, 
  xfSalesGroup,
  xSalesGroupData,
  xfOpenSalesGroupModal,
  fFreight,
  fCustomer,
  fLoadedCost,
  fFreight_xonFocus,
  fFreight_xonBlur,
  fCustomer_xonFocus,
  fCustomer_xonBlur,
  sDetailGridData = [],
}) {
  return (
    <div className="Wms-footer">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={12} md={5} lg={5}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <>
              <Grid item xs={2} sm={2} md={2} lg={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Buyer"} />
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2}>
                <CmpInputField
                  xValue={vRdxWmsHead.A_Buyer}
                  xType={"text"} // text/number/password
                  xName={"A_Buyer"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={xErrorMsg.A_Buyer === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Buyer}
                />
              </Grid>
              <Grid item xs={8} sm={8} md={8} lg={8}>
                <CmpSelectField
                  xtabIndex="201"
                  xLabelText="A_Buyername"
                  xValue={vRdxWmsHead.A_Buyer}
                  xOnChange={fBuyer}
                  xName={"A_Buyername"}
                  xData={xBuyer}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_Buyername === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Buyername}
                  xDisable={false}
                />
              </Grid>
            </>

            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Narration"} />
            </Grid>
            <Grid item xs={10} sm={10} md={10} lg={10}>
              <CmpInputField
                xtabIndex="203"
                xValue={vRdxWmsHead.A_Narr}
                xType={"text"} // text/number/password
                xName={"A_Narr"}
                xReadOnly={false}
                xOnChange={fHeadNarration}
                xError={xErrorMsg.A_Narr === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Narr}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={8} lg={12} className="py-1">
              <CmpStatus xStatus={vRdxWmsHead.A_DocStat} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Grid container spacing={0} columns={{ xs: 12, sm: 12, md: 12 }}>
            <Grid item xs={12}>
              <CmpExportExcel
                data={sDetailGridData}
                fileName="Outlet"
                sheetName="Outlet"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={4} sm={4} md={4} lg={6}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Gross & Spl.Disc.Amt"}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_GrossAmt}
                xType={"text"} // text/number/password
                xName={"A_GrossAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_SplDiscAmt1}
                xType={"text"} // text/number/password
                xName={"A_SplDiscAmt1"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Discount"}
                xtextDecoration={"underline"}
                xonClick={fOpenDiscountPercentageModal}
              />
            </Grid>
            <Grid
              item
              xs={1}
              sm={1}
              md={1}
              lg={1}
              onDoubleClick={fOpenDiscountPercentageModal}
            >
              <CmpInputField
                xValue={vRdxWmsHead.A_DiscPerc}
                xType={"text"} // text/number/password
                xName={"A_DiscPerc"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1}>
              <CmpCheckboxField
                xtabIndex="205"
                xChecked={vRdxWmsHead.A_DiscFlag === "Y"}
                xOnChange={fDiscFlag}
                xDisabled={vRdxWmsHead.A_DocStat == "POST" || true}
                xName={"A_DiscFlag"}
                xNameField={""}
                xError={xErrorMsg.A_DiscFlag === "" ? false : true}
                xErrorMessage={xErrorMsg.A_DiscFlag}
              />
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpInputField
                xValue={xFooterObj.A_TDiscAmt}
                xType={"text"} // text/number/password
                xName={"A_TDiscAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_LDiscAmt}
                xType={"text"} // text/number/password
                xName={"A_LDiscAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>

            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"FOC, Excise & Net.Amt"}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5}>
              <CmpInputField
                xValue={xFooterObj.A_FocAmt}
                xType={"text"} // text/number/password
                xName={"A_FocAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5}>
              <CmpInputField
                xValue={xFooterObj.A_NetExcise}
                xType={"text"} // text/number/password
                xName={"A_NetExcise"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={2} sm={2} md={3}>
              <CmpInputField
                xValue={xFooterObj.A_NetAmt}
                xType={"text"} // text/number/password
                xName={"A_NetExcise"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Tax1, Tax2 & Add.Cess"}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5} lg={2.5}>
              <CmpInputField
                xValue={xFooterObj.A_Tax}
                xType={"text"} // text/number/password
                xName={"A_Tax"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5} lg={2.5}>
              <CmpInputField
                xValue={xFooterObj.A_Tax2}
                xType={"text"} // text/number/password
                xName={"A_Tax2"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={2} sm={2} md={3} lg={3}>
              <CmpInputField
                xValue={xFooterObj.A_AddCess}
                xType={"text"} // text/number/password
                xName={"A_AddCess"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Rounding & Amount"}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xtabIndex="205"
                xValue={vRdxWmsHead.A_Rounding}
                xType={"number"} // text/number/password
                xName={"A_Rounding"}
                xReadOnly={false}
                xOnChange={fRounding}
                xError={xErrorMsg.A_Rounding === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Rounding}
                xonFocus={fFocusRounding}
                xonBlur={fBlurRounding}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_LandVal}
                xType={"text"} // text/number/password
                xName={"A_LandVal"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Customs & Freight"}
              />
            </Grid>

            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={vRdxWmsHead.A_Charges1}
                xType={"number"} // text/number/password
                xName={"A_Charges1"}
                xReadOnly={true}
                xOnChange={fCustomer}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
                xonFocus={fCustomer_xonFocus}
                xonBlur={fCustomer_xonBlur}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputFieldGroup
                xValue={vRdxWmsHead.A_LC}
                xType={"number"} // text/number/password
                xName={"A_LC"}
                xReadOnly={true}
                xOnChange={fFreight}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
                xonFocus={fFreight_xonFocus}
                xonBlur={fFreight_xonBlur}
                xOnKeyUp={fLoadedCost}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
